export type LibraryNode = {
  bucket: string;
  category: string;
  subCategory: string;
  path: string;
  children?: LibraryNode[];
};

export type LibraryTreeNode = {
  id: string;
  label: string;
  data: LibraryNode;
  children?: LibraryTreeNode[];
  isRoot?:boolean
};

export function buildLibraryTree(nodes: LibraryNode[]): LibraryTreeNode[] {
  const roots: Record<string, LibraryTreeNode> = {};

  function child(n: LibraryNode): LibraryTreeNode {
    return {
      data: n,
      id: n.path,
      label: n.subCategory,
    };
  }

  function init(n: LibraryNode) {
    if (!roots[n.category]) {
      const children = nodes.filter((c) => c.category === n.category).map(child);
      roots[n.category] = {
        data: n,
        id: n.category,
        label: n.category,
        isRoot: true,
        children,
      };
    }
  }

  nodes.forEach(init);

  const rootList: LibraryTreeNode [] = Object.values(roots);

  console.info('final len', rootList.map(n => n.children).flat().length, 'conf', nodes.length);

  return rootList;
}
